import { createAction } from 'typesafe-actions';

export const PDP_STOCKLIST_SHOWED = createAction('ui/PDP_STOCKLIST_SHOWED')();
